<template>
  <div>
    <v-container grid-list-lg>
      <div class="text-center my-5 text-h6">New Location</div>

      <v-card flat class="outlined">
        <v-container>
          <v-text-field
            outlined
            dense
            :background-color="`${Location.name ? false : 'yellow'}`"
            v-model="Location.name"
            label="Business Name"
            :error-messages="locationNameErrors"
            hint="ie. CellSmart Wireless LLC, El Primo Repairs, Great Deli #4"
          >
          </v-text-field>

          <v-text-field
            outlined
            dense
            :background-color="`${Location.email ? false : 'yellow'}`"
            v-model="Location.email"
            label="Email Address"
            :error-messages="locationEmailErrors"
          >
          </v-text-field>

          <h4>Address</h4>

          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-text-field
                type="text"
                outlined
                dense
                v-model="Location.Address.name"
                @focus="$event.target.select()"
                label="Type"
                hint="ie. Home, Office, Business"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                type="number"
                outlined
                dense
								number
                v-model="Location.Address.phoneNumber"
                @focus="$event.target.select()"
                label="Phone Number"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                type="text"
                outlined
                dense
                :background-color="`${
                  Location.Address.addressLine1 ? false : 'yellow'
                }`"
                v-model="Location.Address.addressLine1"
                :error-messages="addressLine1Errors"
                data-cy="newOrganizationLocationAddressLine1"
                label="Address"
                @focus="$event.target.select()"
                @input="$v.Location.Address.addressLine1.$touch()"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                type="text"
                outlined
                dense
                v-model="Location.Address.addressLine2"
                @focus="$event.target.select()"
                data-cy="newOrganizationLocationAddressLine2"
                label="Address Line 2"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                outlined
                dense
                :background-color="`${
                  Location.Address.city ? false : 'yellow'
                }`"
                type="text"
                v-model="Location.Address.city"
                :error-messages="cityErrors"
                label="City"
                @focus="$event.target.select()"
                @input="$v.Location.Address.city.$touch()"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                outlined
                dense
                :background-color="`${
                  Location.Address.StateId ? false : 'yellow'
                }`"
                :items="states"
                label="State"
                :error-messages="stateIdErrors"
                item-text="name"
                item-value="id"
                v-model="Location.Address.StateId"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                outlined
                dense
                :background-color="`${
                  Location.Address.postalCode ? false : 'yellow'
                }`"
                type="text"
                :error-messages="postalCodeErros"
                v-model="Location.Address.postalCode"
                label="Zip Code"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                outlined
                dense
                :background-color="`${
                  Location.Address.CountryCode ? false : 'yellow'
                }`"
                :items="countries"
                :error-messages="countryCodeErrors"
                label="Country"
                item-text="name"
                item-value="code"
                v-model="Location.Address.CountryCode"
              ></v-autocomplete>
            </v-flex>

            <!-- <v-layout>
                <v-btn
                  large
                  class="white-btn v-btn-with-radius"
                  @click="prevStage"
                  >back</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  large
                  class="white-btn v-btn-with-radius"
                  :disabled="$v.Location.$invalid"
                  @click="nextStage"
                  >continue</v-btn
                >
              </v-layout> -->
          </v-layout>
        </v-container>
      </v-card>

      <v-card flat class="outlined mt-5">
        <v-container>
          <div>
            <h2>Select the plan</h2>
            <ul class="mb-3">
              <li>Customize by adding Extras anytime.</li>
              <li>No hidden fees, cancel any time.</li>
            </ul>
            <h5>Plans</h5>
            <v-item-group mandatory v-model="planIndex">
              <v-container>
                <v-row justify="center">
                  <v-col
                    v-for="(n, i) in plans"
                    :key="i"
                    cols="6"
                    sm="4"
                    md="2"
                  >
                    <v-item v-slot="{ active, toggle }">
                      <v-card
                        :color="active ? 'primary' : ''"
                        class="d-flex align-center"
                        dark
                        @click="toggle"
                      >
                        <v-card-text>
                          <div
                            :class="active ? 'font-weight-bold' : ''"
                            class="text-center white--text"
                          >
                            {{ n }}
                          </div>
                        </v-card-text>
                        <!-- <v-scroll-y-transition>
                              <div
                                v-if="active"
                                class="text-h2 flex-grow-1 text-center"
                              >
                                Active
                              </div>
                            </v-scroll-y-transition> -->
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
            <div class="text-center display-2">{{ plans[planIndex] }}</div>
            <v-list dense v-if="planIndex === 1">
              <v-list-item
                v-for="item in stripePlans"
                v-if="item.recurring.interval === 'year'"
                :key="item.id"
              >
                <v-list-item-content class="pa-0 text-capitalize">
                  <v-list-item-title>
                    {{ item.metadata.package }} package</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >{{ item.metadata.employeeCount }} attendee
                    {{ (item.unit_amount / 100) | currency }}
                    {{ item.recurring.interval }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-card flat color="grey lighten-3" class="rounded-lg">
                    <v-card-text>
                      <v-layout row align-center>
                        <v-btn
                          text
                          icon
                          :disabled="item.quantity === 0 ? true : false"
                          @click="minusQty(item)"
                        >
                          <v-icon small color="black">mdi-minus</v-icon>
                        </v-btn>
                        <div class="black--text px-2">
                          {{ item.quantity }}
                        </div>

                        <v-btn text icon @click="addQty(item)">
                          <v-icon small color="black">mdi-plus</v-icon>
                        </v-btn>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-list dense v-else>
              <v-list-item
                v-for="item in stripePlans"
                v-if="item.recurring.interval === 'month'"
                :key="item.id"
              >
                <v-list-item-content class="pa-0 text-capitalize">
                  <v-list-item-title>
                    {{ item.metadata.package }} package</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >{{ item.metadata.employeeCount }} attendee
                    {{ (item.unit_amount / 100) | currency }}
                    {{ item.recurring.interval }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-card flat color="grey lighten-3" class="rounded-lg">
                    <v-card-text>
                      <v-layout row align-center>
                        <v-btn
                          text
                          icon
                          :disabled="item.quantity === 0 ? true : false"
                          @click="minusQty(item)"
                        >
                          <v-icon small color="black">mdi-minus</v-icon>
                        </v-btn>
                        <div class="black--text px-2">
                          {{ item.quantity }}
                        </div>

                        <v-btn text icon @click="addQty(item)">
                          <v-icon small color="black">mdi-plus</v-icon>
                        </v-btn>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <!-- <v-radio-group v-model="items" :mandatory="false">
                <v-radio
                  v-for="item in plans"
                  :key="item.id"
                  v-if="item.id !== 3"
                  :label="item.name"
                  :value="item"
                ></v-radio>
              </v-radio-group> -->
            <!-- v-show="items && parseFloat(items.amount) > 0" -->
            <v-card
              flat
              transition="v-scale-transition"
              v-if="employeeCount > 0"
            >
              <v-card-text>
                <v-layout column align-center justify-center>
                  <h4 class="my-2">Payment Method</h4>
                  <div class="text-center mb-2">
                    <strong>{{ employeeCount }}</strong> Employees
                    <strong>{{ (chargeAmount / 100) | currency }}</strong>
                    every <strong>{{ interval }}</strong>
                  </div>
                  <!-- <div v-if="cards">
                    <div class="text-center font-weight-bold black--text">
                      Select Existing Card
                    </div>
                    <v-radio-group v-model="selectedCard">
                      <v-radio
                        v-for="c in cards"
                        :key="c.id"
                        :label="`${c.brand} - ${c.last4}`"
                        :value="c"
                      ></v-radio>
                    </v-radio-group>
                  </div> -->
                  <!-- <div class="mb-2">or Add new one</div>
                  <AddCard @reloadCard="loadCards" /> -->
                  <v-card flat transition="v-scale-transition">
                  <v-card-text>
                    <v-layout column align-center justify-center>
                      <CollectCard @token="submit"></CollectCard>
                    </v-layout>
                  </v-card-text>
                </v-card>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
          <!-- <div v-else>
              You're all set. Confirm the terms and condition to finalize your
              sign up.
            </div> -->
        </v-container>
      </v-card>
    </v-container>
    <v-footer app>
      <v-card-text>
        <v-layout>
          <v-btn color="primary" text @click="homePage" >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="employeeCount > 0 ? false : true"
            @click="getToken"
            :loading="isLoading"
            >Create</v-btn
          >
        </v-layout>
      </v-card-text>
    </v-footer>
  </div>
</template>

<script>
import EventBus from "@/event-bus.js";
// import timezones from "compact-timezone-list";
import AddCard from "@/modules/Location/components/AddCard.vue";
// import organizationService from "@/modules/BackOffice/service.js";
import publicService from "@/api/public";
const { validationMixin } = require("vuelidate");
const { required, minLength, email } = require("vuelidate/lib/validators");
import CollectCard from "@/components/CollectCard.vue";
import settingsService from "@/modules/BackOffice/service.js";
import locationService from "@/modules/Location/service.js";

export default {
  name: "new-location",
  data() {
    return {
      isLoading: false,
      employeeCount: 0,
      chargeAmount: 0,
      interval: "year",
      states: [],
      countries: [],
      stripePlanId: null,
      stripePlans: [],
      plans: ["Monthly", "Yearly"],
      items: null,
      planIndex: 1,
      clientEmail: process.env.VUE_APP_CLIENT_EMAIL,
      clientName: process.env.VUE_APP_CLIENT_NAME,
      customer: null,
      cards: null,
      selectedCard: null,
      // Location: {
      //   name: "saqib store new",
      //   type: "store",
      //   timeZone: this.$moment.tz.guess() || "America/New_York",
      //   email: "saqib+24@cellsmartpos.com",
      //   Address: {
      //     name: "store",
      //     addressLine1: "1989 universtiy ave",
      //     addressLine2: null,
      //     addressLine3: null,
      //     city: "bronx",
      //     StateId: 39,
      //     CountryCode: 840,
      //     phoneNumber: "7182992222",
      //     postalCode: "11563",
      //   },
      // },
      Location: {
        name: null,
        type: null,
        website: null,
        DCALicense: null,
        timeZone: this.$moment.tz.guess() || "America/New_York",
        email: null,
        Address: {
          name: null,
          addressLine1: null,
          addressLine2: null,
          addressLine3: null,
          city: null,
          StateId: null,
          CountryCode: 840,
          phoneNumber: null,
          postalCode: null
        },
      },
    };
  },
  created() {
    console.log("this.$route.params", this.$route.params);
    if (this.$route.params && !this.$route.params.Organization) {
      return this.$router.go(-1);
    }

    this.getPriceList();

    // publicService
    //   .GetPlans({ audience: "CUSTOMCLOCKIN" })
    //   .then((response) => {
    //     console.log("plans", response);
    //     this.stripePlanId = response.data[0].planId;
    //     this.getPriceList();
    //     // this.plans = response.data
    //     // if (this.$route.params.plan && response.data.length > 0) {
    //     //   this.Location.planId = this.$route.params.plan
    //     //   this.items = response.data[0]
    //     // }
    //   });
    this.getState();
    this.getCountry();
    // this.loadCards();
    this.items = this.plans[this.planIndex];
    // publicService
    //   .GetPlans({ planId: this.$route.params.plan, includeIntegrations: true })
    //   .then(response => {
    //     this.plans = response.data
    //     if (this.$route.params.plan && response.data.length > 0) {
    //       this.Location.planId = this.$route.params.plan
    //       this.items = response.data[0]
    //     }
    //   })
  },
  watch: {
    planIndex(val) {
      // this.items = this.plans[val];
      if (val === 0) {
        this.interval = "month";
      } else {
        this.interval = "year";
      }
      this.stripePlans.map((row) => {
        row.quantity = 0;
      });
      this.employeeCount = 0;
      this.chargeAmount = 0;
    },
  },
  components: { CollectCard, AddCard },
  computed: {
    locationNameErrors() {
      const errors = [];
      if (!this.$v.Location.name.$dirty) return errors;
      if (!this.$v.Location.name.required) errors.push("Field Is Required");
      if (!this.$v.Location.name.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    locationEmailErrors() {
      const errors = [];
      if (!this.$v.Location.email.$dirty) return errors;
      if (!this.$v.Location.email.email)
        errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    addressLine1Errors() {
      const errors = [];
      if (!this.$v.Location.Address.addressLine1.$dirty) return errors;
      if (!this.$v.Location.Address.addressLine1.minLength)
        errors.push("Address Must Have At Least 2 Characters");
      if (!this.$v.Location.Address.addressLine1.required)
        errors.push("Field Is Required");
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.$v.Location.Address.city.$dirty) return errors;
      if (!this.$v.Location.Address.city.required)
        errors.push("Field Is Required");
      return errors;
    },
    postalCodeErros() {
      const errors = [];
      if (!this.$v.Location.Address.postalCode.$dirty) return errors;
      if (!this.$v.Location.Address.postalCode.required)
        errors.push("Field Is Required");
      return errors;
    },
    stateIdErrors() {
      const errors = [];
      if (!this.$v.Location.Address.StateId.$dirty) return errors;
      if (!this.$v.Location.Address.StateId.required)
        errors.push("Field Is Required");
      return errors;
    },
    countryCodeErrors() {
      const errors = [];
      if (!this.$v.Location.Address.CountryCode.$dirty) return errors;
      if (!this.$v.Location.Address.CountryCode.required)
        errors.push("Field Is Required");
      return errors;
    },
  },
  methods: {
    homePage() {
      this.$router.push({path: '/backoffice'})
    },
    // loadCards() {
    //   // this.$emit("update");
    //   return settingsService.Billing.getCards()
    //     .then((response) => {
    //       // Data comes straight from stripe and they model their data inside data
    //       console.log("response.data", response.data);
    //       this.cards = response.data.data;
    //       // if (this.cards.length === 1)
    //       //   this.$emit("updateDefault", this.cards[0]);
    //       // this.$Progress.finish();
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       // this.$Progress.error();
    //     });
    // },
    getCustomer() {
      return settingsService.Billing.getCustomer()
        .then((response) => {
          console.log("response.data", response.data);
          // Data comes straight from stripe and they model their data inside data
          this.customer = response.data;

          // if (this.customer && this.customer.default_source) {
          //   this.defaultCardId = this.customer.default_source;
          // }

          // if (this.subscription && this.subscription.default_source) {
          //   this.defaultCardId = this.subscription.default_source;
          // }
        })
        .catch((error) => {
          console.log(error);
          // this.$Progress.error();
        });
    },
    updateEmployeeCount() {
      this.employeeCount = 0;
      this.chargeAmount = 0;
      this.items = [];
      this.stripePlans.map((item) => {
        // console.log('item.quantity', item.employeeCount)
        this.employeeCount +=
          parseInt(item.quantity) * parseInt(item.metadata.employeeCount);
        this.chargeAmount += parseInt(item.quantity) * item.unit_amount;
        if (item.quantity !== 0) {
          this.items.push(item);
        }
      });
    },
    minusQty(row) {
      row.quantity--;
      this.updateEmployeeCount();
      this.$forceUpdate();
    },
    addQty(row) {
      row.quantity++;
      this.updateEmployeeCount();
      this.$forceUpdate();
    },
    getPriceList() {
      // const obj = {
      //   stripe: {
      //     product: this.stripePlanId,
      //     active: true,
      //     recurring: {
      //       interval: "year",
      //     },
      //   },
      // };
      // console.log("sending obj", obj);
      // publicService
      //   .getPriceList({
      //     stripe: {
      //       product: this.stripePlanId,
      //       active: true,
      //       recurring: {
      //         interval: "year",
      //       },
      //     },
      //   })
      //   .then((response) => {
      //     console.log("price list", response.data);
      //     this.yearPlan = response.data.data;
      //     this.yearPlan.map((row) => {
      //       row.quantity = 0;
      //     });
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     this.$toast.error(err.data ? err.data.message : "Error", {
      //       timeout: 2000,
      //     });
      //   });
      if (process.env.NODE_ENV === 'development') {
        this.stripePlanId = 'prod_OeRj9N1bJCpwbd'
      } else {
        this.stripePlanId = 'prod_Of83o9hyqfwHtI'
      }
      publicService
        .getPriceList({
          stripe: {
            product: this.stripePlanId,
            active: true,
          },
        })
        .then((response) => {
          console.log("price list", response.data);
          this.stripePlans = response.data.data;
          this.stripePlans.map((row) => {
            row.quantity = 0;
            // row.employeeCount = 0
          });
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
    getToken() {
      EventBus.$emit("get-card");
    },
    getState() {
      return publicService.States().then((response) => {
        // console.log("responseresponse", response);
        this.states = response.data;
      });
    },
    async submit(cardToken) {
      console.log("selected plan", this.$v);
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Missing Fields", { timeout: 2000 });
        return false
      }
      // if (!this.selectedCard) {
      //   this.$toast.error("Select card or add new one", { timeout: 5000 });
      // }
      // else if (
      //   !this.complete &&
      //   this.items &&
      //   parseFloat(this.items.amount) > 0
      // ) {
      //   this.$toast.error("Card is required.", {
      //     timeout: 2000,
      //   });
      // }
      else {
        this.isLoading = true;
        // If card was added then we need to create the token before creating the organization
        // if (this.complete) {
        //   const data = await createToken();
        //   this.Organization.cardToken = data.token.id;
        // }

        // Check if plan was selected
        // this.Location.planId = "prod_KLaNtVtxdXkHip";
        console.log("this.items", this.Location);

        // let obj = {
        //   Location: this.Location,
        //   planId: "prod_KLaNtVtxdXkHip",
        //   items: [],
        //   cardId: this.selectedCard.id,
        // };

        this.Location.planId = this.stripePlanId
        this.Location.items = []
        // this.Location.cardId = this.selectedCard.id

        await Promise.all(
          this.items.map((item) => {
            this.Location.items.push({
              price: item.id,
              quantity: item.quantity,
            });
          })
        );
        // const cardToken = await this.pay();
        // console.log("cardToken", cardToken);
        if (cardToken && cardToken.error) {
          this.$toast.error(
            cardToken.error ? cardToken.error.message : "Error",
            {
              timeout: 3000,
            }
          );
          this.isLoading = false;
          return;
        }

        // obj.cardToken = cardToken.token.id;

        this.Location.cardToken = cardToken.token.id;
      console.log('sending obj', this.Location)
        locationService
          .create(this.Location)
          .then((response) => {
            this.isLoading = false;
            console.log("response", response.data);
            // localStorage.setItem(
            //   `${process.env.VUE_APP_STORAGE_PREFIX}organizationId`,
            //   response.data.id
            // );
            this.$router.push({ path: "/backoffice" });
            // return this.initOrganization(response.data)
            //   .then(() => {
            //     this.$router.push({ path: "/" });
            //   })
            //   .catch((error) => {
            //     console.log(error);
            //   });
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error(error.data.message, {
              position: "top-right",
              showHideTransition: "slide",
              icon: "error",
              duration: 4000,
            });
            this.isLoading = false;
          });
      }
    },
    getCountry() {
      return publicService.Country().then((response) => {
        // console.log("responseresponse", response);
        this.countries = response.data;
      });
    },
  },
  mixins: [validationMixin],
  validations: {
    Location: {
      name: {
        required,
        minLength: minLength(4),
      },
      email: {
        email,
      },
      Address: {
        addressLine1: {
          required,
          minLength: minLength(2),
        },
        city: {
          required,
        },
        postalCode: {
          required,
        },
        StateId: {
          required,
        },
        CountryCode: {
          required,
        },
      },
    },
  },
};
</script>

<style scoped>
</style>